import type { FC } from "react";

export interface IReviewCard {
  text1: any;
  text2: any;
  profile: any;
  rating: any;
}

const ReviewCard: FC<IReviewCard> = ({ text1, text2, profile, rating }) => {
  return (
    <div className="relative lg:w-[25vw] 2xl:w-[20vw] flex bg-[#056E9C0A] text-black border border-opacity-40 border-slate-200 py-4 rounded-[13px] items-center gap-2">
      <div className="p-1 bg-[#FFCD0D] rounded-full flex items-center justify-center text-xs relative bottom-5 left-4 z-10 ">
        {rating}
      </div>
      <div className="relative flex items-center justify-start">
        {/* <img src={im} alt="" /> */}
        <img
          className="absolute w-[60px] h-[60px] rounded-full border-black right-2"
          src={profile}
        />
        <div className="pl-10 w-[60px] h-[60px] bg-sky-700 bg-opacity-10 rounded-full border-black" />
      </div>
      <div className="text-[15px] font-poppins">
        <p className="text-neutral-600 font-normal ">{text1} </p>
        <p className="text-sky-700">{text2}</p>
      </div>
    </div>
  );
};

export default ReviewCard;
